import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const DataStreamAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const count = 20;
  for (let i = 0; i < count; i++) {
    const angle = (i / count) * Math.PI * 2;
    const dist = e.maxRadius + progress * 150;
    const r = getRadiusAtAngle(angle, e, dist);
    const px = e.pos.x + Math.cos(angle) * r;
    const py = e.pos.y + Math.sin(angle) * r;
    ctx.fillText(Math.random() > 0.5 ? "1" : "0", px, py);
  }
};

registerBlastAnimation('DATA_STREAM', DataStreamAnimation);
